var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleBroken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.6664 35.105V38.0183C69.6625 44.847 67.4513 51.4914 63.3626 56.9607C59.2739 62.43 53.5267 66.4311 46.9783 68.3673C40.4299 70.3035 33.431 70.071 27.0255 67.7045C20.62 65.338 15.1511 60.9643 11.4344 55.2357C7.71768 49.5071 5.95235 42.7305 6.40165 35.9166C6.85096 29.1027 9.49083 22.6167 13.9276 17.4257C18.3643 12.2347 24.3602 8.617 31.0209 7.11208C37.6817 5.60717 44.6505 6.29569 50.888 9.07496M69.6663 12.6668L37.9997 44.3652L28.4997 34.8652",
    stroke: "#039855",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBroken);
export default __webpack_public_path__ + "static/media/check-circle-broken.4a10aa6873e15c494d370566c423a091.svg";
export { ForwardRef as ReactComponent };